import { motion } from "framer-motion";
import { ArrowLeft, Heart } from "lucide-react";

export const FavoritesView = ({ favorites, onClose, onOpen, onRemove }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="absolute inset-0 z-30 bg-[#F5F3ED] overflow-y-auto"
      data-testid="favorites-view"
    >
      <div className="paper-grain absolute inset-0 pointer-events-none" />

      {/* Header */}
      <div className="relative z-10 flex items-center justify-between px-6 pt-6 pb-2">
        <button
          onClick={onClose}
          data-testid="favorites-back"
          aria-label="Back"
          className="rounded-full p-2 -ml-2 text-[#4A5D4E] hover:bg-[#EAE6DF] transition-colors"
        >
          <ArrowLeft className="w-5 h-5" strokeWidth={1.5} />
        </button>
        <span className="font-ui text-[10px] md:text-xs uppercase tracking-[0.4em] text-[#96918A]">
          Favourites
        </span>
        <span className="w-9" />
      </div>

      <div className="relative z-10 px-6 pb-16">
        {favorites.length === 0 ? (
          <div
            className="flex flex-col items-center justify-center text-center py-32 max-w-sm mx-auto"
            data-testid="favorites-empty"
          >
            <Heart className="w-7 h-7 text-[#96918A] mb-6" strokeWidth={1.2} />
            <p className="font-serif-verse italic text-lg md:text-xl text-[#4A5D4E] leading-relaxed">
              Save the verses that speak to you.
            </p>
            <p className="font-ui text-sm text-[#6A6661] mt-3 leading-relaxed">
              They’ll be here when you need them.
            </p>
          </div>
        ) : (
          <ul className="mt-4 space-y-3 max-w-2xl mx-auto" data-testid="favorites-list">
            {favorites.map((v) => (
              <li
                key={v.reference + v.translation + v.addedAt}
                className="group rounded-xl border border-[#E5E1D8] bg-[#F5F3ED]/80 backdrop-blur-sm p-5 transition-colors hover:bg-[#EAE6DF]/70"
                data-testid={`favorite-${v.reference.replace(/\s+/g, "-")}`}
              >
                <button
                  onClick={() => onOpen(v)}
                  className="text-left w-full"
                >
                  <p className="font-serif-verse text-[#05030A] text-lg md:text-xl leading-snug font-bold">
                    “{v.text}”
                  </p>
                  <div className="mt-3 flex items-center gap-2">
                    <span className="font-serif-verse italic text-base text-[#05030A] font-semibold">
                      {v.reference}
                    </span>
                    <span className="font-ui text-[9px] uppercase tracking-[0.2em] text-[#96918A]">
                      {v.translation}
                    </span>
                  </div>
                </button>
                <div className="mt-3 flex items-center justify-end">
                  <button
                    onClick={() => onRemove(v)}
                    data-testid={`favorite-remove-${v.reference.replace(/\s+/g, "-")}`}
                    aria-label="Remove from favourites"
                    className="font-ui text-[10px] uppercase tracking-[0.2em] text-[#96918A] hover:text-[#4A5D4E] transition-colors"
                  >
                    Remove
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </motion.div>
  );
};
